// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpSecondaryTabCmpProposCaracts extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.secondary_tab.cmp_propos_caracts";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpSecondaryTabCmpProposCaracts {
        this.VALUES ??= this.completar({
            "valor": {
                "ca-ES": "Propòsits i Característiques",
                "cz": "Účely a funkce",
                "da": "Formål og funktioner",
                "de": "Ziele und Merkmale",
                "en": "Purposes and features",
                "eu": "Helburuak eta ezaugarriak",
                "fi": "Tarkoitukset ja ominaisuudet",
                "fr": "Finalités et Caractéristiques",
                "ga-ES": "Propósitos e características",
                "hi": "उद्देश्य और विशेषताएं",
                "hu": "Célok és jellemzők",
                "it": "Propositi e Caratteristiche",
                "no": "Formål og funksjoner",
                "nl": "Doeleinden en kenmerken",
                "pl": "Cele i cechy",
                "pt": "Objetivos e Características",
                "pt-BR": "Objetivos e recursos",
                "ro": "Scopuri și caracteristici",
                "ru": "Соглашения и характеристики",
                "sv": "Syften och funktioner",
                "sk": "Účely a vlastnosti"
            },
            "defecto": "Propósitos y Características"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
